import React from 'react';
import TotalToggle from 'pages/search/components/search-component/filters/modules/transient/total-toggle';
import { MonthlyAvailability } from './availability/MonthlyAvailability';
export const FiltersMonthly = () => {
    return (<>
            <TotalToggle />
            <MonthlyAvailability />
        </>);
};
